<template>
  <div :id="uuid" :style="style"></div>
</template>

<script>
import * as echarts from "echarts";
import chinaMap from "@/utils/map.json";
import Pinyin from "@/utils/Pinyin";
const idGen = () => {
  let id = new Date().getTime() + "" + Math.random() * 10000;
  return id;
};

export default {
  props: {
    height: {
      type: String,
      default: "100%",
    },
    width: {
      type: String,
      default: "100%",
    },
    minHeight: {
      type: String,
      default: "auto",
    },
    minWidth: {
      type: String,
      default: "auto",
    },
    options: {
      type: Object,
      default: null,
    },
    dataObj: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      uuid: null,
      myChart: null,
    };
  },

  watch: {
    width(a, b) {
      if (this.myChart) {
        setTimeout(() => {
          this.myChart.resize({
            animation: {
              duration: 300,
            },
          });
        }, 0);
      }
    },

    // options() {
    //   if (this.myChart) {
    //     this.myChart.setOption(this.options, {
    //       notMerge: true,
    //     });
    //   }
    // },
    options: {
      handler(newVal) {
        if (this.myChart) {
          this.myChart.setOption(this.options, {
            notMerge: true,
          });
        } else {
        }
      },
      deep: true,
    },
  },

  computed: {
    style() {
      return {
        height: this.height,
        width: this.width,
        "min-height": this.minHeight,
        "min-width": this.minWidth,
      };
    },
  },

  created() {
    this.uuid = idGen();
  },

  mounted() {
    // let chinaMapCopy = chinaMap;
    // chinaMapCopy.features.forEach((el) => {
    //   el.properties.name = Pinyin(el.properties.name);
    // });
    //
    echarts.registerMap("china", { geoJSON: chinaMap });
    // 准备实例
    let echart = echarts.init(document.getElementById(this.uuid));
    this.myChart = echart;
    window.addEventListener("resize", function () {
      echart.resize();
    });

    // 应用配置项
    this.myChart.setOption(this.options);
    // 监听区域选中事件
    echart.on("click", function (params) {
      // console.log(3333, params);
    });
  },
};
</script>
